import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/lib/reveal";
import polaroid from "@/assets/begin-polaroid.jpg";

const SCHEDULE_URL =
  "https://care.headway.co/providers/april-cook-suravallop?utm_source=pem&utm_medium=direct_link&utm_campaign=219222";

export function Begin() {
  return (
    <section
      id="begin"
      data-testid="begin-section"
      aria-labelledby="begin-heading"
      className="relative py-24 sm:py-32"
    >
      <h2 id="begin-heading" className="sr-only">
        I’m here when you’re ready — begin therapy at The Inkwell
      </h2>
      <div className="mx-auto max-w-5xl px-6 sm:px-8">
        <Reveal>
          <div className="border border-haint/25 bg-[#d9e2e0] px-6 py-14 text-center text-lightink sm:px-16 sm:py-20">
            <figure className="mx-auto max-w-xl">
              <img
                src={polaroid}
                alt="A Polaroid of Maya, a character in The Inkwell's story, standing at the shoreline at sunset holding red shoes — handwritten beneath: I'm here when you're ready."
                data-testid="begin-sunset-image"
                loading="lazy"
                width={980}
                height={850}
                className="w-full shadow-[0_18px_50px_-12px_rgba(23,27,32,0.35)]"
              />
            </figure>
            <p className="mx-auto mt-10 max-w-md text-sm leading-relaxed text-lightink/60">
              Scheduling is handled through the secure link below.
            </p>
            <div className="mt-8">
              <a
                href={SCHEDULE_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="begin-booking-link"
                aria-label="View availability and book with April via Headway (opens in a new tab)"
                className="group inline-flex items-center gap-4 rounded-sm border border-lightink px-10 py-4 font-mono text-xs tracking-[0.25em] uppercase text-lightink transition-colors duration-500 hover:bg-lightink hover:text-[#d9e2e0]"
              >
                View availability
                <ArrowUpRight
                  className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1"
                  aria-hidden="true"
                />
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
